import { render } from "./ProductSpec.vue?vue&type=template&id=78df2a8a"
import script from "./ProductSpec.vue?vue&type=script&lang=js"
export * from "./ProductSpec.vue?vue&type=script&lang=js"

import "./ProductSpec.vue?vue&type=style&index=0&id=78df2a8a&lang=css"

import exportComponent from "F:\\admin_om\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__